import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import moment from "moment";

const ExpiryChangePopup = ({ 
  isOpen, 
  toggle, 
  onSubmit, 
  initialDate, 
  title = "Change Date",
  isLoading = false 
}) => {
  const [selectedDate, setSelectedDate] = useState('')
  
  useEffect(() => {
    setSelectedDate('');
  }, []);

  const handleSubmit = () => {
    onSubmit(selectedDate);
  };

  function toggle2() {
    toggle();
    setSelectedDate('');
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle2}>
      <ModalHeader toggle={toggle2}>{title}</ModalHeader>
      <ModalBody>
        <input
          type="date"
          className="form-control"
          min={moment().format("YYYY-MM-DD")}
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button 
          color="primary" 
          onClick={handleSubmit}
          disabled={!selectedDate || isLoading}
          style={{width: "100px"}}
        >
          {isLoading ? <Spinner  size="sm"/> : "Submit"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ExpiryChangePopup;